import StudentRenderer from "Components/ModelRenderers/StudentRenderer";
import { StudentPicker } from "Components/StudentPicker";
import IStyle from "Interfaces/IStyle";
import Student, { NumberedStudent } from "Models/Student";
import StudentMap from "Models/StudentMap";
import { focusTextBox, sortByLevenshteinDistance } from "Utils/Common";
import { GrandTourneyTeamRenderer } from "Views/Tools/GrandTournament";
import React, { useMemo, useState } from "react";
import { Alert, Button, CloseButton, Col, Row } from "react-bootstrap";

interface IPlayerTeamProps {
}

const TEAMS_KEY = "midokuni.tools.teambuilder.teams"
const storedTeams = localStorage.getItem(TEAMS_KEY);
const initialTeams = storedTeams ? JSON.parse(storedTeams) : [CreateTeam()];
const studentMap = new StudentMap();
const UNMATCH_VISIBLE = false;
const MAX_RESULTS = 50;

const MAX_STRIKERS = 4;
const MAX_SPECIALS = 2;
const MAX_STUDENTS = MAX_SPECIALS + MAX_STRIKERS;
const styles:IStyle = {
	icon: {
		textAlign: "center"
	},
	dim: {
		opacity: 0.2
	},
	container: {
		padding: 10,
		margin: 5,
		border: "1px solid",
		// borderColor: "violet",
		borderRadius: 20,
		borderColor: "pink",
	},
	brand: {
		marginTop: 10
	},
	closeButton: {
		textAlign: "right"
	},
	highlight: {
		border: "10px solid",
		// borderColor: "violet",
		borderRadius: 20,
		borderColor: "pink",
	}
}

function CreateTeam() {
	return ["EMPTY","EMPTY","EMPTY","EMPTY","EMPTY","EMPTY"];
}
export default function TeamBuilder(props: IPlayerTeamProps) {
	const id = "team-builder";
	const [isSwap, setIsSwap] = useState(false);
	const [searchString, setSearchString] = useState("");
	const isSearchVisible = true;
	// const isSearchVisible = props.active;
	// const [isSearchVisible, setIsSearchVisible] = useState(true);
	const [students, _setStudents] = useState(initialTeams?.[0] ?? CreateTeam());
	const setStudents = (s: string[]) => {
		_setStudents(s);
		localStorage.setItem(TEAMS_KEY, JSON.stringify([s]));
		const teams = [];
		let team = [];
		for(const member of s) {
			if (member === "EMPTY") {
				team.push(null);
			} else {
				team.push(studentMap.getId(member) ?? member);
			}
			if (team.length === 6) {
				teams.push(team);
				team = [];
			}
		}
	}
	const [dragging, setDragging] = useState<number>(null);
	const teams = useMemo(() => {
		const toRet:Student[][] = [];
		for(let i=0; i<students.length;) {
			const team = [
				Student.fromName(studentMap.getProperName(students[i++])),
				Student.fromName(studentMap.getProperName(students[i++])),
				Student.fromName(studentMap.getProperName(students[i++])),
				Student.fromName(studentMap.getProperName(students[i++])),
				Student.fromName(studentMap.getProperName(students[i++])),
				Student.fromName(studentMap.getProperName(students[i++])),
			];
			toRet.push(team);
		}
		return toRet;
	}, [students]);
	const [selectedIndex, setSelectedIndex] = useState<number>(0);
	// const setSelectedBanIndex = (a:number) => setSelectedIndex(a%banNumber);

	const [matches, unmatches] = useMemo(()=>{
		const data1 = [...new Set(studentMap.getStudentNames().filter((n) => n.toLowerCase().indexOf(searchString.toLowerCase()) >= 0 && n.length > 0).map(n => studentMap.getProperName(n)))];
		const data2 = [...new Set(studentMap.getStudentNames().filter((n) => n.toLowerCase().indexOf(searchString.toLowerCase()) < 0 && n.length > 0).map(n => studentMap.getProperName(n)))];
		
		if (searchString.trim().length === 0) {
			if (data1.length < 9) {
				// const temp = data2.splice(9-data1.length);
				data1.push(...data2);
				return [[...new Set(data1)].filter((_,i)=>i <= MAX_RESULTS), data2];

			}

			return [data1.sort(), data2.sort()];
		}
		const toRet = [sortByLevenshteinDistance(data1, searchString), sortByLevenshteinDistance(data2, searchString)];
		if (toRet[0].length < 9) {
			// const temp = toRet[1].splice(9-data1.length);
			toRet[0].push(...toRet[1]);
			return [[...new Set(toRet[0])].filter((_,i)=>i <= MAX_RESULTS), toRet[1]];
		}

		return [toRet[0].filter((_,i)=>i <= MAX_RESULTS), toRet[1]];
	}, [searchString]);
	function addStudent(student: string) {
		if (students.indexOf(student) >= 0) {
			// STUDENT ALREADY IN TEAM
		}
		
		let test = [...students];
		if (selectedIndex+1 >= students.length) {
			test = [...students, ...CreateTeam()];
		} 
		test[selectedIndex] = student;
		setStudents(test);
		setSelectedIndex( selectedIndex+1 );
		focusTextBox(`${id}-team-search`);
	}
	const xs = 8;

		return (<>
		<Alert>
			This is mostly a port of the team builder for the Grand Tournament Referee tool. I plan to improve this but for now this should work. I did this for my own planning anyway.
		</Alert>
		<Row>
			<Col xs={xs-1} style={styles.container}>
				<Row>
					<Col>
						<Button variant="violet" onClick={()=>setIsSwap(!isSwap)}>Swap Student Position</Button>
					</Col>
				</Row>
				{teams.map((team, i) => {
					return <Row key={`team_${i}`}>
						<Col><GrandTourneyTeamRenderer compact highlight={Math.floor(selectedIndex/MAX_STUDENTS) === i ? selectedIndex % MAX_STUDENTS : undefined} 
						handleDrag={(e, studenti) => {
							e.preventDefault();
							if (!!dragging) return;
							setDragging(i*MAX_STUDENTS + studenti)
							setSelectedIndex(i*MAX_STUDENTS + studenti)
						}}
						handleDrop={(e, studenti) => {
							e.preventDefault();
							// e.stopPropagation();
							setDragging(null)
							
							const prevSelected = students[selectedIndex];
							const currSelected = students[i*MAX_STUDENTS + studenti];
							
							let tempStudents = [...students];
							tempStudents[selectedIndex] = currSelected;
							tempStudents[i*MAX_STUDENTS + studenti] = prevSelected;
							setStudents(tempStudents);
						}}
						handleClick={(studenti)=>{
							if (isSwap) {
								const prevSelected = students[dragging];
								const currSelected = students[i*MAX_STUDENTS + studenti];
								
								let tempStudents = [...students];
								tempStudents[selectedIndex] = currSelected;
								tempStudents[i*MAX_STUDENTS + studenti] = prevSelected;
								setStudents(tempStudents);
								focusTextBox(`${id}-team-search`);
								setIsSwap(false);
							} 
							setSelectedIndex(i*MAX_STUDENTS + studenti)
							focusTextBox(`${id}-team-search`);
						}} 
						team={team} /></Col>
						<Col xs={1}>
							<Row hidden={i===0}><Col><Button variant="violet" onClick={(e)=>{
								const temp = [...students];
								const teamRemoved = temp.splice(MAX_STUDENTS * i, MAX_STUDENTS);
								temp.splice(MAX_STUDENTS * (i-1), 0, ...teamRemoved)
								setStudents(temp);
							}}>&uarr;&uarr; &darr;&darr;</Button></Col></Row>
							<Row><Col><Button variant="danger" style={{marginTop: "10%"}} onClick={(e)=>{
								const temp = [...students];
								temp.splice(MAX_STUDENTS * i, MAX_STUDENTS);
								setStudents(temp);
							}}><CloseButton aria-label="Add-Team"/>DEL</Button></Col></Row>
						</Col>
					</Row>
					})}
				<Row><Col><Alert hidden={!isSwap} variant="primary">Select the student to swap positions with.</Alert></Col></Row>
				<Row style={{paddingLeft: "10%", paddingRight: "10%"}}>
					{/* <Col> */}
						<Button variant="violet" onClick={(e)=>{
							setStudents([...students, ...CreateTeam()]);
							focusTextBox(`${id}-team-search`);
						}}><CloseButton style={{marginLeft:5, transform: "rotate(45deg)"}} aria-label="Add-Team"/> Add Team</Button>
					{/* </Col> */}
				</Row>

			</Col>
			<Col style={{...styles.container, ...(!isSearchVisible ? styles.dim:undefined)}} 
		// hidden={!isSearchVisible}
		>
			<Row style={{height: "max-content"}}>
				<Col>
					<Row>
						<Col>
						Automatically adds a new team if needed
						</Col>
					</Row>
					<Row>
						<Col>
							<StudentPicker disableAutofill id={`${id}-team-search`} ignoreNumericSpecials setTarget={(target) => setSearchString(target ?? "")} target={searchString} handleKeyDown={(e, setText) => {
								const {key, shiftKey, altKey, ctrlKey} = e;
								if (key === "Tab" || key === "Enter") {
									addStudent(matches[0]);
									setText("");
									setSearchString("");
									focusTextBox(`${id}-team-search`);
									return;
								} 
								let i = parseInt(key);
								if (Number.isNaN(i)) return;
								if (key === "0") return;
								i--;
								if(matches.length <= i) return;
								addStudent(matches[i]);
								setText("");
								setSearchString("");
								focusTextBox(`${id}-team-search`);
							}} />
						</Col>
					</Row>
					<Row style={{overflowY: "scroll", maxHeight: "70vh"}}>
						{matches.slice(0, Math.min(matches.length, 9)).map((id, i)=><Col key={id} xs={6} md={4} onClick={(e)=>{
							addStudent(id)
						}}>
							<Row><Col><StudentRenderer disableSchale compact bare model={NumberedStudent.fromNameWithNumber(studentMap.getProperName(id), i+1)} /></Col></Row>
						</Col>
						)}
						<hr></hr>
						<hr></hr>
						{matches.slice(Math.min(matches.length, 9)).map(id=><Col key={id} xs={6} md={4}  onClick={(e)=>{
							addStudent(id)
						}}>
							<StudentRenderer disableSchale compact bare model={Student.fromName(studentMap.getProperName(id))} />
						</Col>
						)}
						<hr></hr>
						<hr></hr>
						{UNMATCH_VISIBLE && unmatches.map(id=><Col key={id} xs={6} md={4} onClick={(e)=>{
							addStudent(id)
						}}>
							<StudentRenderer disableSchale compact bare model={Student.fromName(studentMap.getProperName(id))} />
						</Col>
						)}
					</Row>
				</Col>
			</Row>
		</Col>
		</Row>
	</>);
}